import { jsxs, jsx } from 'react/jsx-runtime';
import { Body, Caption, CustomLink, styled, CommonStyles, Title, SubTitle, Row, Col, isMobile } from '@teko/ds-desktop';
import { __rest } from 'tslib';
import { RightOutlined } from '@teko/ds-icon';
import { useState } from 'react';
import { t } from '../i18n.es.js';
import { u as useTimer } from '../useTimer-33c14ff7.js';
import { P as ProductCarousel } from '../ProductCarousel-be468b91.js';
import { g as getTrackingData } from '../tracking-3282e302.js';
import { g as getImageUrlFromGoogleUserContent } from '../image-b1bfb7c2.js';
import { C as Countdown } from '../Countdown-526a64ba.js';
import 'i18next';
import '../time-41e6541a.js';
import '../constants.es.js';
import '../HorizontalSlider-494405e6.js';
import '../ProductCard-1836695b.js';
import '../helpers.es.js';
import '../number-e3270bb3.js';
import '@teko/types/ecommerce';
import '../megaMenu-0ccc961e.js';
import './FlashSaleBar.es.js';
import '../CountdownTime-80b32bdc.js';
import '../useQuantity-8bb9ae80.js';
import '../FlashSaleBadge-fef23775.js';
import '../SavingBadge-b884a4be.js';
import '../ProductPrice-03190dcc.js';
import '../EnhancedImage-5956213c.js';
import '@teko/types/shared';

const Tab$2 = (_a) => {
    var { tabs, className } = _a, props = __rest(_a, ["tabs", "className"]);
    const [tabIndex, setTabIndex] = useState(0);
    const handleChangeTab = (event) => {
        setTabIndex(+event.currentTarget.dataset.index);
    };
    const timer = useTimer(tabs[tabIndex].endAt);
    return (jsxs(TabWrapper$1, Object.assign({}, props, { children: [jsx(TabHeader$1, { children: tabs.slice(0, 4).map((tab, index) => (jsxs(TabItem$1, Object.assign({ "data-index": index, onClick: handleChangeTab, className: index === tabIndex ? 'active' : '' }, { children: [jsx(Body, Object.assign({ level: 1, weight: "medium", line: 2, className: "title" }, { children: tab.title }), void 0), tab.description && (jsx(Caption, Object.assign({ level: 3, weight: "regular", line: 2 }, { children: tab.description }), void 0)), jsxs(Timer, { children: [timer.hours.toString().padStart(2, '0'), "\u00A0:\u00A0", timer.minutes.toString().padStart(2, '0'), "\u00A0:\u00A0", timer.seconds.toString().padStart(2, '0')] }, void 0), jsx(Decor, {}, void 0)] }), index))) }, void 0), jsxs(Wrapper, Object.assign({ bgImage: tabs[tabIndex].backgroundImage, className: className }, { children: [jsx("div", Object.assign({ style: { textAlign: 'right', padding: '32px 16px' } }, { children: tabs[tabIndex].link && (jsxs(CustomLink, Object.assign({ href: tabs[tabIndex].link }, { children: [jsx("span", Object.assign({ style: { color: 'white' } }, { children: t('Xem tất cả') }), void 0), jsx(RightOutlined, { color: "white" }, void 0)] }), void 0)) }), void 0), jsx(ProductCarousel, Object.assign({}, tabs[tabIndex].productsCarousel), void 0)] }), void 0)] }), void 0));
};
const TabWrapper$1 = styled.div(CommonStyles);
const Wrapper = styled.div `
  background: url(${(props) => props.bgImage});
  background-size: cover;
  background-position: center center;
  margin-bottom: 8px;
  padding: 16px 8px;
`;
const TabHeader$1 = styled.div `
  height: 60px;
  display: flex;
  margin-left: 16px;
`;
const TabItem$1 = styled.div(({ theme }) => `
  width: 84px;
  height: 84px;
  text-align: center;
  margin-right: 8px;
  padding: 16px 4px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  background: white;
  color: ${theme.colors.textSecondary};
  border: 1px solid ${theme.colors.border};
  border-radius: 8px;
  position: relative;
  &.active {
    background: ${theme.colors.primary700};
    color: white;
    padding: 0;
    transition: all 0.2s ease-in-out 0s;
    border-style: none;
    .title{
      color: white;
    }
  }
`);
const Decor = styled.div(({ theme }) => `
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  position: absolute;
  bottom: -5px;
  .active & {
    background: ${theme.colors.primary700};
  }
`);
const Timer = styled.div(({ theme }) => `
  padding: 0 8px;
  font-size: 10px;
  background: white;
  border-radius: 5px;
  display: none;
  z-index: 5;
  .active & {
    color: ${theme.colors.link700};
    display: block;
    font-weight: 400;
  }
`);

const Tab$1 = (_a) => {
    var { tabs, className } = _a, props = __rest(_a, ["tabs", "className"]);
    const [tabIndex, setTabIndex] = useState(0);
    const handleChangeTab = (event) => {
        setTabIndex(+event.currentTarget.dataset.index);
    };
    return (jsxs(TabWrapper, Object.assign({ bgImage: tabs[tabIndex].backgroundImage, className: className }, props, { children: [jsx(TabHeader, { children: tabs.map((tab, index) => (jsxs(TabItem, Object.assign({ "data-index": index, onClick: handleChangeTab, className: index === tabIndex ? 'active' : '' }, getTrackingData({
                    isTrackContent: true,
                    regionName: 'hotDealTab',
                    contentName: tab.title,
                }), { children: [jsx(Title, Object.assign({ line: 1, style: { textAlign: 'center' } }, { children: tab.title }), void 0), tab.description && (jsx(SubTitle, Object.assign({ line: 1, style: { textAlign: 'center' } }, { children: tab.description }), void 0))] }), index))) }, void 0), jsx("div", Object.assign({ style: { position: 'relative', textAlign: 'right', padding: '20px' } }, { children: tabs[tabIndex].link && (jsxs(CustomLink, Object.assign({ href: tabs[tabIndex].link }, { children: [jsx("span", Object.assign({ style: { color: 'white' } }, { children: t('Xem tất cả') }), void 0), jsx(RightOutlined, { color: "white" }, void 0)] }), void 0)) }), void 0), jsxs(Row, { children: [jsx(Col, Object.assign({ span: 2, style: { margin: 'auto' } }, { children: jsx(CountdownTime, { date: tabs[tabIndex].endAt }, void 0) }), void 0), jsx(Col, Object.assign({ span: 10 }, { children: jsx(Carousel, { children: jsx(ProductCarousel, Object.assign({}, tabs[tabIndex].productsCarousel, { regionName: "hotDeal" }), void 0) }, void 0) }), void 0)] }, void 0)] }), void 0));
};
const TabWrapper = styled.div `
  ${CommonStyles}
  ${(p) => p.bgImage &&
    `background-image: url(${getImageUrlFromGoogleUserContent(p.bgImage || '', {
        width: 1232,
    })});
background-repeat: no-repeat;
background-size: cover;`}
  border-radius: 8px;
  padding-bottom: 12px;
`;
const TabHeader = styled.div `
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px 8px 0px 0px;
`;
const TabItem = styled.div `
  height: 60px;
  padding: 0.5rem 1rem 0 1rem;
  border-radius: 5px 5px 0 0;
  flex: 1;
  cursor: pointer;
  background: white;
  color: rgb(132, 135, 136);
  position: relative;
  &.active {
    background: transparent;
    color: white;
  }
  &:not(:first-child):before {
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid white;
    position: absolute;
    left: -5px;
    top: 0;
  }
`;
const CountdownTime = styled(Countdown) `
  position: relative;
  left: 1rem;
  bottom: 0;
`;
const Carousel = styled.div `
  margin-left: 48px;
  margin-right: 16px;
`;

const Tab = (props) => {
    if (isMobile)
        return jsx(Tab$2, Object.assign({}, props), void 0);
    return jsx(Tab$1, Object.assign({}, props), void 0);
};

export { Tab };
